import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import LoadingIcon from "./LoadingIcon";
import { getDefaultPath } from "../utils/defaultRedirectUtils";
import Landing from "../pages/landing/Landing";

const DefaultRedirect = ({ skipPath = null }) => {
  const {
    userData,
    isAuthenticated,
    isAdmin,
    hasOrgPermission,
    isFetchingProfile,
  } = useUser();

  if (isFetchingProfile) {
    return <LoadingIcon height="200px" classname="absolute h-full" />;
  }

  if (!isAuthenticated()) {
    return <Landing />;
  }

  const defaultPath = getDefaultPath({
    userData,
    isAdmin,
    hasOrgPermission,
    skipPath,
  });

  return <Navigate to={defaultPath} replace />;
};

export default DefaultRedirect;
